// OverviewSection.tsx — без props, берёт из контекста
import React from "react";
import { Row, Col } from "antd";
import styles from "../index.module.scss";
import { useVaadTabs } from "../VaadTabs/context";
import { formatDefaultTime } from "../../../../../utils";

function capitalize(str: string): string {
  if (!str) return "";
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function formatTimezone(tz?: string): string {
  return tz || "None";
}

export default function OverviewSection(): React.ReactElement {
  const { vaadData, selectedMiddahId } = useVaadTabs();

  // Находим выбранную мидду
  const selectedMiddah = vaadData?.learnedMiddahs?.find(
    (m) => m.middah.id === selectedMiddahId,
  );

  const topRow = [
    {
      label: "Vaad Status",
      value: capitalize(String(vaadData?.status.replace(/_/g, " "))),
    },
    { label: "Vaad ID", value: String(vaadData?.vaadId) },
    { label: "Audience", value: capitalize(String(vaadData?.type)) },
    {
      label: "Currently studied Middah",
      value: String(
        selectedMiddah?.middah.name || vaadData?.middah?.name || "None",
      ),
    },
  ];

  const bottomRow = [
    { label: "Location", value: String(vaadData?.address) },
    {
      label: "Meetings default date",
      value:
        [
          capitalize(vaadData?.defaultDay || ""),
          formatDefaultTime(vaadData?.defaultTime),
        ]
          .filter(Boolean)
          .join(", ") || "None",
    },
    {
      label: "Leader",
      value:
        `${vaadData?.user?.firstName || ""} ${vaadData?.user?.lastName || ""}`.trim() ||
        "None",
    },
    {
      label: "Timezone",
      value: formatTimezone(vaadData?.timezone),
    },
  ];

  return (
    <div className={styles.section}>
      <h3 className={styles.title}>Overview</h3>

      <Row gutter={[24, 20]}>
        {topRow.map((item) => (
          <Col key={item.label} span={6}>
            <div className={styles.item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          </Col>
        ))}
      </Row>

      <Row gutter={[24, 0]} style={{ marginTop: 18 }}>
        {bottomRow.map((item) => (
          <Col key={item.label} span={6}>
            <div className={styles.item}>
              <span className={styles.label}>{item.label}</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
}
